<template>
  <div class="personalized-emails w100">
    <h1 class="bold">
      Personalized emails churn
      <br>
      <span>
        Send personalized emails churn to RS users
      </span>
    </h1>

    <div class="prompts-group">
      <details class="pointer" v-for="(item, index) in buttons"
               :key="index">
        <summary>Prompt for {{ item.name }} email &nbsp;</summary>
        <textarea
            :value="prompts[item.key]"
            @input="handlePrompt($event, item.key)"
            placeholder="job description"
        />
        <button class="purple-btn block"
                @click="handlePromptSave(item.key)">
            <span class="spinner" v-if="isSaving"/>
            {{isSaving ? 'Saving...' : 'Save changes'}}
        </button>
      </details>
    </div>
  </div>
</template>

<script setup>
  import {useStore} from "vuex";
  import {computed} from "vue";

  const {state, dispatch, commit} = useStore();
  dispatch('get_prompts_churn');

  const prompts = computed(() => state.personalizedEmailsChurn.prompts);
  const isSaving = computed(() => state.reqStatus === "saving");
  const buttons = [
    {name: '1st', key: 'prompt1'},
    {name: '2nd', key: 'prompt2'},
    {name: '3rd', key: 'prompt3'},
  ];

  function handlePrompt (ev, key) {
    commit('UPDATE_PROMPT_CHURN', {key, value: ev.target.value});
  }

  function handlePromptSave (key) {
    if (isSaving.value) return
    dispatch('save_prompts_churn', key)
  }
</script>

<style lang="scss">
  .personalized-emails {
    @media only screen and (min-width: 0) {
      .email {
        width: 450px;
        margin-bottom: 30px;
      }
      .purple-btn {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .prompts-group {
        details {
          margin-top: 30px;
          summary {
            color: #ababab;
            font-size: 1.8rem;
            font-weight: 700;
          }
          textarea {
            width: 600px;
            height: 300px;
            margin-top: 30px;
          }
          &:first-child {
            textarea {
              width: 100%;
              height: 200px;
              margin-top: 30px;
            }
          }
          button {
            margin-top: 19px;
          }
        }
      }
    }
  }
</style>